
import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-12-11T00:00:00+03:00").getTime();

function getRemaining() {
  const diff = Math.max(0, TARGET - Date.now());
  const seconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(seconds / 86400),
    hours: Math.floor((seconds % 86400) / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
    complete: diff === 0,
  };
}

export default function ZetechCountdown() {
  const [time, setTime] = useState(getRemaining);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const units = [
    ["DAYS", time.days],
    ["HOURS", time.hours],
    ["MINUTES", time.minutes],
    ["SECONDS", time.seconds],
  ];

  return (
    <section
      aria-label="Countdown to 11 December 2026"
      style={{
        background: "linear-gradient(135deg, #081C46, #153467)",
        color: "#fff",
        padding: "48px 20px",
        borderRadius: "20px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
      }}
    >
      <p style={{ color: "#F5C542", fontWeight: 700 }}>
        ZETECH UNIVERSITY
      </p>

      <h2 style={{ fontSize: "clamp(22px, 4vw, 36px)" }}>
        Countdown to 10th Graduation Ceremony 2026
      </h2>

      <p>Every second brings us closer.</p>

      {time.complete ? (
        <h3 role="status">The day has arrived!</h3>
      ) : (
        <div
          role="timer"
          aria-live="off"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: "clamp(6px, 2vw, 20px)",
            maxWidth: "760px",
            margin: "32px auto",
          }}
        >
          {units.map(([label, value]) => (
            <div
              key={label}
              style={{
                background: "#153467",
                border: "1px solid #47648E",
                borderRadius: "12px",
                padding: "clamp(12px, 3vw, 24px) 4px",
                minWidth: 0,
              }}
            >
              <div
                style={{
                  fontSize: "clamp(24px, 5vw, 56px)",
                  fontWeight: 800,
                  color: "#F5C542",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {String(value).padStart(2, "0")}
              </div>
              <div
                style={{
                  fontSize: "clamp(9px, 1.5vw, 13px)",
                  letterSpacing: "0.04em",
                }}
              >
                {label}
              </div>
            </div>
          ))}
        </div>
      )}

      <p style={{ fontSize: "13px", opacity: 0.85 }}>
        FRIDAY • 11 DECEMBER 2026 • 7:00 AM EAT . Venue: Zetech University Technology Park Mang'u Campus, Kenya
      </p>
      <br />
      <p style={{ fontSize: "13px", opacity: 0.85 }}>
        <a href="https://shahada.zetech.ac.ke" style={{ color: "#F5C542", textDecoration: "underline" }}>
          CLEARANCE AND GRADUATION PORTAL. 
        </a>
      </p>
    </section>
  );
}
